import { Calendar } from '@prenuvo/halo-icon';
import { Button } from '@prenuvo/halo-web';
import { CalendarEvent, google } from 'calendar-link';

interface AddToCalendarProps {
  calendarEvent: CalendarEvent;
}

export const AddToCalendar = ({ calendarEvent }: AddToCalendarProps) => {
  return (
    <div>
      <Button
        leftIcon={Calendar}
        onClick={() => {
          const googleCalendarUrl = google(calendarEvent);
          window.open(googleCalendarUrl, '_blank');
        }}
        size="lg"
        variant="text"
      >
        Add to Calendar
      </Button>
    </div>
  );
};
